import { render, staticRenderFns } from "./cPolicyNotice.vue?vue&type=template&id=244e4828&"
import script from "./cPolicyNotice.vue?vue&type=script&lang=js&"
export * from "./cPolicyNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports